<template>
  <v-dialog v-model="show" persistent width="400px">
    <v-card>
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-card-title>
          <span v-if="msg" class="subheading" v-html="$t('vmail.moveToCustomFolder.title')" />
          <span v-if="bulk" class="subheading" v-html="$t('vmail.moveToCustomFolder.bulkTitle')" />
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <msg-info v-if="msg" :msg="msg" />
          <span v-if="bulk" v-html="$t('vmail.moveToCustomFolder.bulkIntro', { count: bulk.length })" />
          <v-combobox class="mt-6"
              v-model="customerFolder"
              :label="$t('vmail.moveToCustomFolder.folderLabel')"
              :placeholder="$t('vmail.moveToCustomFolder.folderPlaceholder')"
              :items="customFolders"
              dense
              clearable
              :rules="[requiredRule, validateInput]"
              outlined
              data-testid="move-to-custom-folder-input"
              hide-no-data>
            </v-combobox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text v-html="$t('vmail.moveToCustomFolder.btnCancel')" @click="$emit('close')" data-testid="move-to-custom-folder-close" />
          <v-btn
            text
            v-html="$t('vmail.moveToCustomFolder.btnMoveToCustomFolder')"
            @click="submit()"
            :disabled="!valid"
            color="primary"
            data-testid="move-to-custom-folder-submit"
          />
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MsgInfo from './msg_info'

export default {
  name: 'voicemails-move-to-custom-folder',
  components: { MsgInfo },
  data () {
    return {
      valid: false,
      customerFolder: null,
      loading: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      required: false
    },
    bulk: {
      type: Array,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      customFolders: 'voicemails/customFolders'
    })
  },
  methods: {
    ...mapActions({
      moveToCustomFolder: 'voicemails/moveToCustomFolder',
      bulkMoveToCustomFolder: 'voicemails/bulkMoveToCustomFolder'
    }),
    requiredRule (value) {
      return !!value || this.$t('vmail.moveToCustomFolder.errors.folderNameRequired')
    },
    validateInput (value) {
      const regex = /^[A-Za-z]{3,10}$/
      const prohibitedValues = ['greet', 'busy', 'unavail', 'temp', 'inbox', 'old', 'archive']

      if (!regex.test(value)) {
        return this.$t('vmail.moveToCustomFolder.errors.invalidFolderName')
      }
      if (prohibitedValues.includes(value?.toLowerCase())) {
        return this.$t('vmail.moveToCustomFolder.errors.reservedFolderName')
      }
      return true
    },
    submit () {
      this.loading = true
      const customFolder = this.customerFolder
      if (this.bulk?.length > 0) {
        const ids = this.bulk.map(msg => msg.id)
        this.bulkMoveToCustomFolder({ ids, customFolder })
      } else if (this.msg) {
        const id = this.msg.id
        this.moveToCustomFolder({ id, customFolder })
      }
      this.loading = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
</style>
